import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToLocalDate } from "../../../utils/dateConvert";
import { downloadCSVFile } from "../../../api/apiClient";
import Location from '../../commoncomponents/location';
import { formatTemperatureReading, getValidTemperature, temperatureReadingClass } from '../../../utils/temperature';

function PointTable(props) {
  let assetCustomerName = props.assetCustomerName;
  let timeZone = props.timeZone ? props.timeZone.toString().slice(25, 55) : '';
  let createdData = [];
  if (props.pointData.length > 0) {
    props.pointData.forEach((firstObj) => {
      createdData.push(firstObj);
    });
  }

  const data = (
    <Table striped responsive>
      <thead>
        <tr className="nowwrapTH">
          <th>ID</th>
          <th>Name</th>

          <th>Entered POI Zone</th>
          <th>Exited POI Zone</th>
          <th>Location</th>

          <th>Duration</th>
          <th>Engine Hours</th>
          <th>Fridge Hours</th>

          <th>Fridge</th>
          <th>TempA</th>
        </tr>
      </thead>
      <tbody>
        {createdData.map((element, index) => {
          return (
            <tr>
              <td>{index + 1}</td>
              <td>{element.poiName}</td>
              <td>{utcToLocalDate(element.entered)}</td>
              <td>{utcToLocalDate(element.exited)}</td>
              <td>
                <Location
                  address={element.location}
                  lat={element.latitude}
                  lng={element.longitude}
                />
              </td>
              <td>{element.duration}</td>
              <td>{element.engineDuration}</td>
              <td>{element.fridgeDuration}</td>
              <td>
                <span className={`fridge-pill ${element.fridge ? "fridge-on" : "fridge-off"}`}>
                  {element.fridge ? "On" : "Off"}
                </span>
              </td>
              <td className={temperatureReadingClass(element.tempA)}>{formatTemperatureReading(element.tempA)}</td>
            </tr>


          );
        })}
      </tbody>


    </Table>
  );

  const handleDownloadExcel = () => {
    const pointData = props.pointData.map((point) => ({
      ...point,
      tempA: getValidTemperature(point.tempA),
      tempB: getValidTemperature(point.tempB),
    }));
    downloadCSVFile(pointData, "POIReport", assetCustomerName, timeZone);
  };

  return (
    <ToggleBar
      caption="POI Zone Visits (Multiple)"
      icon="fa fa-database"
      color="#A94442"
      content={data}
      download={handleDownloadExcel}
    />
  );
}

export default PointTable;
